import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/administration/_administration/faculty/_faculty')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.faculties' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
